import React from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function TermsNotice() {
  const t = useTranslation()

  return (
    <p className="ai-sign-in-modal__terms cgt-caption">
      {t('signIn.terms.prefix')}
      {' '}
      <a
        className="cgt-link-primary-accented"
        href="/pages/terms-and-conditions"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('signIn.terms.termsLink')}
      </a>
      {' '}
      {t('signIn.terms.and')}
      {' '}
      <a
        className="cgt-link-primary-accented"
        href="/pages/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('signIn.terms.privacyLink')}
      </a>
    </p>
  )
}

export default TermsNotice
